<template>
  <div>
    <v-data-table :items="items" :headers="headers">
      <template v-slot:item.actions="{ item }">
        <slot name="actions" v-bind:item="item"></slot>
      </template>
      <!-- <template v-slot:item.viewMore="{item}">
        <slot name="viewMore" v-bind:item="item"></slot>
      </template>-->
      <template v-slot:item.refDesc="{ item }">
        <span class="dont-break-out">{{ item.refDesc }}</span>
      </template>
      <template v-slot:item.discipMainArtDesc="{ item }">
        <span class="dont-break-out">{{ item.discipMainArtDesc }}</span>
      </template>
      <template v-slot:item.discipSubArtDesc="{ item }">
        <span class="dont-break-out">{{ item.discipSubArtDesc }}</span>
      </template>
      <template v-slot:item.discipDate="{ item }">
        <span>{{ item.discipDate | dateFormat }}</span>
      </template>
      <template v-slot:item.noteExplDate="{ item }">
        <span>{{ item.noteExplDate | dateFormat }}</span>
      </template>
      <template v-slot:item.writExplDate="{ item }">
        <span>{{ item.writExplDate | dateFormat }}</span>
      </template>
      <template v-slot:item.hearingDate="{ item }">
        <span>{{ item.hearingDate | dateFormat }}</span>
      </template>
      <template v-slot:item.memoDate="{ item }">
        <span>{{ item.memoDate | dateFormat }}</span>
      </template>
      <template v-slot:item.suspendedFrom="{ item }">
        <span>{{ item.suspendedFrom | dateFormat }}</span>
      </template>
      <template v-slot:item.suspendedTo="{ item }">
        <span>{{ item.suspendedTo | dateFormat }}</span>
      </template>
      <template v-slot:item.receivedDate="{ item }">
        <span>{{ item.receivedDate | dateFormat }}</span>
      </template>
      <template v-slot:item.terminatedDate="{ item }">
        <span>{{ item.terminatedDate | dateFormat }}</span>
      </template>
      <template v-slot:item.attachment="{ item }">
        <slot name="attachment" v-bind:item="item"></slot>
      </template>
    </v-data-table>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/discCaseMaint";
export default {
  props: {
    empCode: {
      default: null,
      type: String,
    },
    headers: {
      default: () => [
        {
          text: "",
          value: "actions",
          sortable: false,
        },
        {
          text: "IR No.",
          value: "irNo",
          sortable: false,
          width: "300",
        },
        {
          text: "Specific Type",
          value: "refDesc",
          sortable: false,
          width: "300",
        },
        {
          text: "Main Article",
          value: "discipMainArtDesc",
          sortable: true,
          width: "300",
        },
        {
          text: "Sub Article",
          value: "discipSubArtDesc",
          sortable: true,
          width: "300",
        },
        {
          text: "Classification",
          value: "discipClassDesc",
          sortable: true,
        },
        {
          text: "Disciplinary Action",
          value: "discipActionDesc",
          sortable: true,
        },
        {
          text: "Place of Incident",
          value: "incidentPlace",
          sortable: true,
        },
        {
          text: "Incident Date",
          value: "discipDate",
          sortable: false,
        },
        {
          text: "Notice to Explain Date",
          value: "noteExplDate",
          sortable: false,
        },
        {
          text: "Written Explanation Date",
          value: "writExplDate",
          sortable: false,
        },
        {
          text: "Admin Hearing Date",
          value: "hearingDate",
          sortable: false,
        },
        {
          text: "Memo Date",
          value: "memoDate",
          sortable: false,
        },
        {
          text: "Memo Ref No.",
          value: "memoRefNo",
          sortable: false,
        },
        {
          text: "Suspended From",
          value: "suspendedFrom",
          sortable: false,
        },
        {
          text: "Suspended To",
          value: "suspendedTo",
          sortable: false,
        },
        {
          text: "Received Date",
          value: "receivedDate",
          sortable: false,
        },
        {
          text: "Signatory 1",
          value: "sig1FullName",
          sortable: false,
        },
        {
          text: "Signatory 2",
          value: "sig2FullName",
          sortable: false,
        },
        {
          text: "Signatory 3",
          value: "sig3FullName",
          sortable: false,
        },
        {
          text: "With A/R",
          value: "withAR",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
        },
        {
          text: "Amount",
          value: "amount",
          sortable: true,
        },
        {
          text: "No. of Offense",
          value: "noOfOffense",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          sortable: false,
        },
        {
          text: "Preventive Suspension",
          value: "prevSuspension",
          sortable: false,
        },
        {
          text: "Terminated Date",
          value: "terminatedDate",
          sortable: false,
        },
        {
          text: "What",
          value: "what",
          sortable: false,
        },
        {
          text: "Admin Hearing Location",
          value: "adminHearingLoc",
          sortable: false,
        },
        {
          text: "Attachment",
          value: "attachment",
          sortable: false,
        },
      ],
      type: Array,
    },
  },
  data: () => ({
    items: [],
    // headers: [
    //   {
    //     text: "",
    //     value: "actions",
    //     sortable: false
    //   },
    //   {
    //     text: "Specific Type",
    //     value: "refDesc",
    //     sortable: false
    //   },
    //   {
    //     text: "Main Article",
    //     value: "discipMainArtDesc",
    //     sortable: true
    //   },
    //   {
    //     text: "Sub Article",
    //     value: "discipSubArtDesc",
    //     sortable: true
    //   },
    //   {
    //     text: "Classification",
    //     value: "discipClassDesc",
    //     sortable: true
    //   },
    //   {
    //     text: "Disciplinary Action",
    //     value: "discipActionDesc",
    //     sortable: true
    //   },
    //   {
    //     text: "Place of Incident",
    //     value: "incidentPlace",
    //     sortable: true
    //   },
    //   {
    //     text: "Amount",
    //     value: "amount",
    //     sortable: true
    //   },
    //   // {
    //   //   text: "View More",
    //   //   value: "viewMore",
    //   //   sortable: false
    //   // },
    //   {
    //     text: "Attachment",
    //     value: "attachment",
    //     sortable: false
    //   }
    // ]
  }),
  methods: {
    getByEmpCode(empCode) {
      this.$axios
        .get(`${API_ENDPOINT}/${empCode}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.success(response.data.message);
        });
    },
  },
  created() {
    this.getByEmpCode(this.empCode);
  },
  watch: {
    empCode(val) {
      this.getByEmpCode(val);
    },
  },
};
</script>
